import React from "react";
import LatestNews from "../../components/LatestNews";
import UserList from "../../components/UserList";
import SuggestedClubs from "../../components/SuggestedClubs";


function Users() {
  return (
    <div className="right-panel-inner">
        <div className="post-section">
            <h2 className="mb-20">Users</h2>
            <UserList/>
        </div>
        <div className="right-side-bar">
          <LatestNews/>
          <SuggestedClubs/>
        </div>
    </div>
  );
}

export default Users;